export function getSiteUrl(): string {
  const envUrl = process.env.REACT_APP_SITE_URL;
  if (envUrl && envUrl.trim()) return envUrl.replace(/\/+$/, "");

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return "https://nwa-blog.com";
}

export function canonicalUrl(pathname: string): string {
  const siteUrl = getSiteUrl().replace(/\/+$/, "");
  const safePath = pathname?.startsWith("/") ? pathname : `/${pathname || ""}`;
  return `${siteUrl}${safePath === "/" ? "/" : safePath}`;
}

export function absoluteAssetUrl(assetPath: string): string {
  const siteUrl = getSiteUrl().replace(/\/+$/, "");
  const safePath = assetPath?.startsWith("/")
    ? assetPath
    : `/${assetPath || ""}`;
  return `${siteUrl}${safePath}`;
}
